import { render } from "./Apng.vue?vue&type=template&id=ffecacc2"
import script from "./Apng.vue?vue&type=script&lang=js"
export * from "./Apng.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__